import React from "react";
import { LayoutProvider, RouteContext } from "./src/context/layoutContext";
import { MenuDataProvider } from "./src/context/menuDataContext";

export const wrapPageElement = ({ element, props }) => {
	if (!element) return null;

	// Esta movida permite meter elementos como children del contexto de i18next, para poder usar traducciones en Context components de todas las páginas
	const newElement = React.cloneElement(
		element, // I18nextProvider
		element.props,
		React.cloneElement(
			element.props.children, // I18nextContext.Provider
			element.props.children.props,
			<RouteContext.Provider value={{ location: props.location }}>
				<LayoutProvider>
					<MenuDataProvider>
						{element.props.children.props.children}
					</MenuDataProvider>
				</LayoutProvider>
			</RouteContext.Provider>,
		),
	);

	return newElement;
};
